// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert {
  box-shadow: 0 16px 10px -17px rgba(0, 0, 0, 0.5);
  transform: translate(-50%, -50%);
  z-index: 2000;
  position: fixed;
  display: flex;
  align-items: center;
  left: 50%;
  top: 50%;
  width: 40%;
  height: 80px;
}

.alert-danger {
  background-color: rgba(223, 0, 8, 0.831372549);
  color: white;
}

.warning {
  background-color: #f89406;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/error/top-alert.component.scss"],"names":[],"mappings":"AAAA;EACE,gDAAA;EACA,gCAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;AACF;;AAEA;EACE,8CAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF","sourcesContent":[".alert {\n  box-shadow: 0 16px 10px -17px rgba(0, 0, 0, 0.5);\n  transform: translate(-50%, -50%);\n  z-index: 2000;\n  position: fixed;\n  display: flex;\n  align-items: center;\n  left: 50%;\n  top: 50%;\n  width: 40%;\n  height: 80px;\n}\n\n.alert-danger {\n  background-color: #df0008d4;\n  color: white;\n}\n\n.warning {\n  background-color: #f89406;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
